module.exports = __webpack_public_path__ + "static/8-59ca3ab057162af3d90c8d6c06c60759.jpeg";